import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, Checkbox, Col, Row, Alert, Form, Input, Button, Image } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import UrlParse from 'url-parse';
import GeneralHelper from '../../helpers/general';

class LoginPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			password: ''
		};
	}
	componentWillUnmount() {
		this.props.resetPage();
	}
	componentDidMount() {
		// const query = GeneralHelper.queryStringToObject(this.props.location.search);
		const { query } = UrlParse(this.props.history.location.search, true);
		this.props.showLoginForm({ query });
	}
	onFieldChange = data => {
		this.setState({ ...this.state, [data.target.name]: data.target.value });
	};
	onKeyPress = e => {
		const { pageProps } = this.props;
		const { loading } = pageProps;
		const { email, password } = this.state;
		if (email.trim() !== '' && password.trim() !== '' && !loading && this.validateEmail(email.trim())) {
			if (e.key === 'Enter') {
				this.onSubmit();
			}
		}
	};
	onSubmit = e => {
		const { email, password } = this.state;
		const query = GeneralHelper.queryStringToObject(this.props.location.search);
		this.props.login({ email, password, query });
	};

	validateEmail = email => {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	render() {
		const { email, password } = this.state;
		const { pageProps } = this.props;
		const { loading, showLoginForm } = pageProps;

		if (!showLoginForm) {
			return null;
		}

		return (
			<Row
				className="login-container"
				justify="center"
				align="middle"
			>
				<Card className="login-card">
					<Col className="gutter-row booking-custom-form-container">
						<Row
							style={{ marginBottom: '30px' }}
						>
							<Image
								src={`${GeneralHelper.getImageBasePath()}/images/HKUST-logo.png`}
								preview={false}
							/>
						</Row>
						<Form
							initialValues={{ remember: true }}
							name="vertical_signup"
							layout="vertical"
						>
							<Form.Item
								rules={[{ type: 'email', required: true, message: 'Please input a valid email' }]}
							>
								<Input
									name="email"
									onChange={data => this.onFieldChange(data)}
									onKeyPress={this.onKeyPress}
									placeholder="Email"
									style={{ borderRadius: 3, height: 40 }}
									prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.5)' }} />}
								/>

							</Form.Item>
							<Form.Item
								style={{ marginTop: 10 }}
							>
								<a
									href="##"
									style={{ position: 'absolute', right: 0, color: 'rgba(0,0,0,.5)' }}
								>
									Forgot your password?
								</a>
								<Input
									name="password"
									onChange={data => this.onFieldChange(data)}
									onKeyPress={this.onKeyPress}
									placeholder="Password"
									type="password"
									style={{ borderRadius: 3, marginTop: 25, height: 40 }}
									prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.5)' }} />}
								/>
							</Form.Item>
							<Checkbox
								style={{ color: 'rgba(0,0,0,.5)', marginTop: 10 }}
							>Remember me</Checkbox>

							{pageProps && pageProps.error !== '' && (
								<div>
									<Alert
										description={pageProps && pageProps.error !== '' && pageProps.error}
										type="error"
										style={{ marginTop: 10, marginBottom: 10 }}
									/>
								</div>
							)}

							<div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
								<Button
									disabled={email.trim() === '' || password.trim() === '' || loading || !this.validateEmail(email.trim())}
									loading={loading}
									onClick={this.onSubmit}
									style={{
										background: '#003366',
										color: '#fff',
										border: 'none',
										borderRadius: 3,
										height: 40,
										opacity: (email.trim() === '' || password.trim() === '' || loading || !this.validateEmail(email.trim())) && 0.5,
										cursor: email.trim() !== '' && password.trim() !== '' && 'pointer',
										width: '100%'
									}}
								>
									Login
								</Button>
							</div>

							<div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
								<Button
									loading={loading}
									onClick={this.onSubmit}
									style={{
										background: '#ffffff',
										color: '#003366',
										borderRadius: 3,
										height: 40,
										cursor: 'pointer',
										width: '100%'
									}}
								>
									Login with CAS
								</Button>
							</div>
						</Form>


					</Col>
				</Card>
			</Row>
		);
	}
}

LoginPage.propTypes = {
	pageProps: PropTypes.object.isRequired,
	onFieldChange: PropTypes.func.isRequired,
	login: PropTypes.func.isRequired
};

export default LoginPage;
